import React from 'react';
import Header from '../Header/Header';

const NotFound = () => {
    return (
        <div>
            <Header></Header>
            <h1>This is NotFound</h1>
        </div>
    );
};

export default NotFound;